/**
 * @param {number} appNo
 * @param {number} offerNo
 * @param {number} productId
 * @param {number} ssn
 * @param {number} ssnCo
 * @param {number} amountApplied
 * @param {number} amountApproved
 * @param {number} amountDocs
 * @param {number} amountDocsTopUp
 * @param {number} repaymentYears
 * @param {number} interestRate
 * @param {number} interestRateEffective
 * @param {number} interestRateTopUp
 * @param {number} monthlyCost
 * @param {number} maxMonthlyCost
 * @param {number} monthlyCostTopUp
 * @param {number} monthlyCostPPITopUp
 * @param {number} applicationFee
 * @param {number} noticeFee
 * @param {number} autogiroFee
 * @param {number} annualFee
 * @param {number} withdrawalFee
 * @param {number} monthlyFee
 * @param {number} pledgeFee
 * @param {number} redeemRequired
 * @param {number} statusId
 * @param {number} subStatusId
 * @param {number} createdDate
 * @param {number} updatedDate
 * @param {number} appliedDate
 * @param {number} informedCustomerDate
 * @param {number} sendDocsDate
 * @param {number} docsCustomerDate
 * @param {number} docsReturnedDate
 * @param {number} paidOutDate
 * @param {number} annulledDate
 * @param {object} product
 * @param {object} productInfo
 * @param {object} productCustomerSupportLanguage
 * @constructor
 */
const offer = (
  {
    appNo = undefined,
    offerNo = undefined,
    productId = undefined,
    ssn = undefined,
    ssnCo = undefined,
    amountApplied = undefined,
    amountApproved = undefined,
    amountDocs = undefined,
    amountDocsTopUp = undefined,
    repaymentYears = undefined,
    interestRate = undefined,
    interestRateEffective = undefined,
    interestRateTopUp = undefined,
    monthlyCost = undefined,
    maxMonthlyCost = undefined,
    monthlyCostTopUp = undefined,
    monthlyCostPPITopUp = undefined,
    applicationFee = undefined,
    noticeFee = undefined,
    autogiroFee = undefined,
    annualFee = undefined,
    withdrawalFee = undefined,
    monthlyFee = undefined,
    pledgeFee = undefined,
    redeemRequired = undefined,
    statusId = undefined,
    subStatusId = undefined,
    createdDate = undefined,
    updatedDate = undefined,
    appliedDate = undefined,
    informedCustomerDate = undefined,
    sendDocsDate = undefined,
    docsCustomerDate = undefined,
    docsReturnedDate = undefined,
    paidOutDate = undefined,
    annulledDate = undefined,
    product = undefined,
    productInfo = undefined,
    productCustomerSupportLanguage = undefined
  } = {}
) => {
  return {
    appNo,
    offerNo,
    productId,
    ssn,
    ssnCo,
    amountApplied,
    amountApproved,
    amountDocs,
    amountDocsTopUp,
    repaymentYears,
    interestRate,
    interestRateEffective,
    interestRateTopUp,
    monthlyCost,
    maxMonthlyCost,
    monthlyCostTopUp,
    monthlyCostPPITopUp,
    applicationFee,
    noticeFee,
    autogiroFee,
    annualFee,
    withdrawalFee,
    monthlyFee,
    pledgeFee,
    redeemRequired,
    statusId,
    subStatusId,
    createdDate,
    updatedDate,
    appliedDate,
    informedCustomerDate,
    sendDocsDate,
    docsCustomerDate,
    docsReturnedDate,
    paidOutDate,
    annulledDate,
    product,
    productInfo,
    productCustomerSupportLanguage
  }
}

module.exports = { offer }
